'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTE_TRANSITION_FINISHED = exports.SET_PERMISSION = exports.APPEND_BOTTOM_CONNECTED_NODE = exports.APPEND_RIGHT_CONNECTED_NODE = exports.APPEND_RIGHT_NODE = exports.APPEND_NEW_NODE = exports.DETACH_NODE = exports.REMOVE_EDGE = exports.ADD_EDGE = exports.REMOVE_NODE = exports.UPDATE_NODES = exports.UPDATE_NODE = exports.ADD_NODE = exports.SHARE_PROJECT_POPUP_OPENED = exports.SHARE_PROJECT_FAILURE = exports.SHARE_PROJECT_SUCCESS = exports.SHARE_PROJECT_GOT_FB_LINK = exports.SHARE_PROJECT = exports.DELETE_PROJECT = exports.SET_PROJECT = exports.UPDATE_PROJECT_NAME = exports.ADD_PROJECT = exports.POPUP_CLOSE_LAST = exports.POPUP_CLOSE = exports.POPUP_SHOW = exports.USER_SET_WELCOME_POPUP_SHOWN = exports.USER_SET_FIRST_LOGIN = exports.SET_EDITOR_NODE = exports.SET_PROJECTS_LIST = exports.SET_SHOWN_USER = exports.LOG_IN_AND_TO_INDEX = exports.SET_AUTHORIZED_USER = exports.SET_AUTHORIZING = exports.LOGGED_IN = exports.LOG_OUT = exports.LOG_IN = exports.NOTIFICATION_RESUME = exports.NOTIFICATION_PAUSE = exports.NOTIFICATION_REMOVE = exports.NOTIFICATION_ADD = exports.API_ERRORS = exports.API_FAILURE = exports.POPUP_ERRORS_SET = exports.ROUTING_ACTIONS_KEYS = undefined;

var _routing = require('./routing');

var ROUTING_ACTIONS = _interopRequireWildcard(_routing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ROUTING_ACTIONS_KEYS = exports.ROUTING_ACTIONS_KEYS = Object.keys(ROUTING_ACTIONS);
/* injects from baggage-loader */

var POPUP_ERRORS_SET = exports.POPUP_ERRORS_SET = 'POPUP_ERRORS_SET';

var API_FAILURE = exports.API_FAILURE = 'API_FAILURE';
var API_ERRORS = exports.API_ERRORS = 'API_ERRORS';

var NOTIFICATION_ADD = exports.NOTIFICATION_ADD = 'NOTIFICATION_ADD';
var NOTIFICATION_REMOVE = exports.NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';

var NOTIFICATION_PAUSE = exports.NOTIFICATION_PAUSE = 'NOTIFICATION_PAUSE';
var NOTIFICATION_RESUME = exports.NOTIFICATION_RESUME = 'NOTIFICATION_RESUME';

var LOG_IN = exports.LOG_IN = 'LOG_IN';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var LOGGED_IN = exports.LOGGED_IN = 'LOGGED_IN';
var SET_AUTHORIZING = exports.SET_AUTHORIZING = 'SET_AUTHORIZING';
var SET_AUTHORIZED_USER = exports.SET_AUTHORIZED_USER = 'SET_AUTHORIZED_USER';
var LOG_IN_AND_TO_INDEX = exports.LOG_IN_AND_TO_INDEX = 'LOG_IN_AND_TO_INDEX';

var SET_SHOWN_USER = exports.SET_SHOWN_USER = 'SET_SHOWN_USER';
var SET_PROJECTS_LIST = exports.SET_PROJECTS_LIST = 'SET_PROJECTS_LIST';

var SET_EDITOR_NODE = exports.SET_EDITOR_NODE = 'SET_EDITOR_NODE';

var USER_SET_FIRST_LOGIN = exports.USER_SET_FIRST_LOGIN = 'USER_SET_FIRST_LOGIN';
var USER_SET_WELCOME_POPUP_SHOWN = exports.USER_SET_WELCOME_POPUP_SHOWN = 'USER_SET_WELCOME_POPUP_SHOWN';

var POPUP_SHOW = exports.POPUP_SHOW = 'POPUP_SHOW';
var POPUP_CLOSE = exports.POPUP_CLOSE = 'POPUP_CLOSE';
var POPUP_CLOSE_LAST = exports.POPUP_CLOSE_LAST = 'POPUP_CLOSE_LAST';

var ADD_PROJECT = exports.ADD_PROJECT = 'ADD_PROJECT';
var UPDATE_PROJECT_NAME = exports.UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME';
var SET_PROJECT = exports.SET_PROJECT = 'SET_PROJECT';
var DELETE_PROJECT = exports.DELETE_PROJECT = 'DELETE_PROJECT';
var SHARE_PROJECT = exports.SHARE_PROJECT = 'SHARE_PROJECT';
var SHARE_PROJECT_GOT_FB_LINK = exports.SHARE_PROJECT_GOT_FB_LINK = 'SHARE_PROJECT_GOT_FB_LINK';
var SHARE_PROJECT_SUCCESS = exports.SHARE_PROJECT_SUCCESS = 'SHARE_PROJECT_SUCCESS';
var SHARE_PROJECT_FAILURE = exports.SHARE_PROJECT_FAILURE = 'SHARE_PROJECT_FAILURE';
var SHARE_PROJECT_POPUP_OPENED = exports.SHARE_PROJECT_POPUP_OPENED = 'SHARE_PROJECT_POPUP_OPENED';

var ADD_NODE = exports.ADD_NODE = 'ADD_NODE';
var UPDATE_NODE = exports.UPDATE_NODE = 'UPDATE_NODE';
var UPDATE_NODES = exports.UPDATE_NODES = 'UPDATE_NODES';
var REMOVE_NODE = exports.REMOVE_NODE = 'REMOVE_NODE';
var ADD_EDGE = exports.ADD_EDGE = 'ADD_EDGE';
var REMOVE_EDGE = exports.REMOVE_EDGE = 'REMOVE_EDGE';
var DETACH_NODE = exports.DETACH_NODE = 'DETACH_NODE';
var APPEND_NEW_NODE = exports.APPEND_NEW_NODE = 'APPEND_NEW_NODE';
var APPEND_RIGHT_NODE = exports.APPEND_RIGHT_NODE = 'APPEND_RIGHT_NODE';
var APPEND_RIGHT_CONNECTED_NODE = exports.APPEND_RIGHT_CONNECTED_NODE = 'APPEND_RIGHT_CONNECTED_NODE';
var APPEND_BOTTOM_CONNECTED_NODE = exports.APPEND_BOTTOM_CONNECTED_NODE = 'APPEND_BOTTOM_CONNECTED_NODE';

var SET_PERMISSION = exports.SET_PERMISSION = 'SET_PERMISSION';

var ROUTE_TRANSITION_FINISHED = exports.ROUTE_TRANSITION_FINISHED = 'ROUTE_TRANSITION_FINISHED';


//////////////////
// WEBPACK FOOTER
// ./app/constants/actionTypes.js
// module id = 23
// module chunks = 1